import React, { ReactElement } from "react";
import { gql, useMutation } from "@apollo/client";
import { 
  ReactivateCustomerAdminMutation, 
  ReactivateCustomerAdminMutationVariables 
} from "../../../../../schemaTypes";
import { normalizeErrors } from "../../../../../utils/normalizeErrors";
import { NormalizedErrorMap } from "../../../../../types/NormalizedErrorMap";

export const reactivateCustomerAdminMutation = gql`
  mutation ReactivateCustomerAdmin($email: String!) {
    reactivateCustomerAdmin(email: $email) {
      errors {
        path
        message
      }
      message
    }
  }
`;

interface Props {
  children: (
    data: {
      submitReactivateCustomerAdmin: (
        values: ReactivateCustomerAdminMutationVariables
      ) => Promise<NormalizedErrorMap | null>;
      loading: boolean;
      errors: NormalizedErrorMap | null;
      message: string | null;
    }
  ) => ReactElement | null;
}

export const ReactivateCustomerAdminController: React.FC<Props> = ({ children }) => {
  const [mutate, { loading, data }] = useMutation<
    ReactivateCustomerAdminMutation,
    ReactivateCustomerAdminMutationVariables
  >(reactivateCustomerAdminMutation);

  const errors = data?.reactivateCustomerAdmin?.errors
    ? normalizeErrors(data.reactivateCustomerAdmin.errors)
    : null;

  const submitReactivateCustomerAdmin = async (
    values: ReactivateCustomerAdminMutationVariables
  ) => {
    const response = await mutate({ variables: values });
    const reactivateCustomerAdmin = response?.data?.reactivateCustomerAdmin;
    if (reactivateCustomerAdmin?.errors) {
      return normalizeErrors(reactivateCustomerAdmin.errors);
    }
    
    return null;
  };

  const message = data?.reactivateCustomerAdmin?.message || null;

  return children({
    submitReactivateCustomerAdmin,
    loading,
    errors,
    message,
  });
};
